import React from "react";
import { useDispatch } from "react-redux";
import TripsIcon from "../../../../../../Common/Svgs/TripsIcon";
import OperationsIcon from "../../../../../../Common/Svgs/OperationsIcon";
import { CalendarWithTickIcon } from "../../../../../../Common/Svgs/CalendarIcon";
import { TickWithBgIcon } from "../../../../../../Common/Svgs/TickIcon";
import ClockIcon from "../../../../../../Common/Svgs/ClockIcon";
import { updateUsers } from "../../../../../../Redux/Slices/users.slice";
import { TIME_OFF_STATUS } from "./constants";

export const ScheduledTrips = ({ data, count }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(
      updateUsers({
        key: "scheduleTripModal",
        value: {
          visible: true,
          data: {
            id: data?.driver?.id,
            name: data?.driver?.name,
            date: data?.date,
            trips: data?.trips,
          },
        },
      }),
    );
  };

  return (
    <div
      role="button"
      className="bg-green-10 hover:bg-[#CEDCDD] w-full p-0.5 flex items-center gap-x-2 rounded-md"
      onClick={handleClick}
    >
      <div className="w-4 h-4 bg-green rounded flex items-center justify-center">
        <TripsIcon size={12} className="text-[#FCFCFC]" />
      </div>

      <p className="font-aileron font-normal text-xs text-black">
        {count} Trips
      </p>
    </div>
  );
};

export const ScheduledSessions = ({ data, count }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(
      updateUsers({
        key: "scheduleSessionModal",
        value: {
          visible: true,
          data: {
            id: data?.driver?.id,
            name: data?.driver?.name,
            date: data?.date,
            sessions: data?.sessions,
          },
        },
      }),
    );
  };

  return (
    <div
      role="button"
      className="bg-[#F8F2E0] hover:bg-[#FDE8A8] w-full p-0.5 flex items-center gap-x-2 rounded-md"
      onClick={handleClick}
    >
      <div className="w-4 h-4 bg-yellow rounded flex items-center justify-center">
        <OperationsIcon size={12} className="text-black" />
      </div>

      <p className="font-aileron font-normal text-xs text-black">
        {count} Sessions
      </p>
    </div>
  );
};

export const ScheduledTimeoff = ({ data }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(
      updateUsers({
        key: "timeoffModal",
        value: {
          visible: true,
          driver: data?.driver,
          timeoff: data?.timeoff,
          status: TIME_OFF_STATUS.APPROVED,
        },
      }),
    );
  };

  return (
    <div
      role="button"
      className="bg-dark-gray w-full p-0.5 flex items-center gap-x-2 rounded-md"
      onClick={handleClick}
    >
      <div className="w-4 h-4 bg-[#FCFCFC] rounded flex items-center justify-center">
        <CalendarWithTickIcon size={12} className="text-black" />
      </div>

      <p className="flex-1 font-aileron font-normal text-xs text-[#FCFCFC]">
        Time-off
      </p>

      <TickWithBgIcon
        size={12}
        className="text-[#FCFCFC]"
        tickColor="#525252"
      />
    </div>
  );
};

export const PendingTimeoff = ({ data }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(
      updateUsers({
        key: "timeoffModal",
        value: {
          visible: true,
          driver: data?.driver,
          timeoff: data?.timeoff,
          date: data?.date,
          status: TIME_OFF_STATUS.PENDING,
        },
      }),
    );
    dispatch(
      updateUsers({
        key: "currentDriver",
        value: {
          id: data?.driver?.id,
          hubId: data?.driver?.hubId,
        },
      }),
    );
  };

  return (
    <div
      role="button"
      className="bg-[#F4DAD6] w-full p-0.5 flex items-center gap-x-2 rounded-md"
      onClick={handleClick}
    >
      <div className="w-4 h-4 bg-alert-red rounded flex items-center justify-center">
        <CalendarWithTickIcon size={12} className="text-[#FCFCFC]" />
      </div>

      <p className="flex-1 font-aileron font-normal text-xs text-alert-red whitespace-nowrap">
        Pending Request
      </p>

      <ClockIcon size={12} fillColor="#c84630" className="text-[#FCFCFC]" />
    </div>
  );
};
